import { render } from "./userFeekback.vue?vue&type=template&id=5be675b5"
import script from "./userFeekback.vue?vue&type=script&lang=js"
export * from "./userFeekback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__